import { DataAttributeDefinitions, provideDataClass } from 'scrivito'

import { DataClassName, PisaDataClassEndpoint } from '@/Data/const'
import { createPisaRestApiConfig } from '@/Data/pisaClient'

const activityProjectRelationDataClassName =
  DataClassName.ACTIVITY_PROJECT_RELATION
const activityProjectRelationEndpoint = PisaDataClassEndpoint.ACTIVITY_PROJECT

export function pisaActivityProjectRelationDataClass(
  attributes: DataAttributeDefinitions,
) {
  return provideDataClass(activityProjectRelationDataClassName, {
    title: activityProjectRelationDataClassName,
    restApi: createPisaRestApiConfig(activityProjectRelationEndpoint),
    attributes,
  })
}
